import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import { queryFlowCopyMan, updateIsRead, saveFlowTrack } from '@/services/flow';
import { getFormCate } from '@/services/form';
var columns = [{
  title: '申请流水号',
  dataIndex: 'fillId',
  align: 'center',
  width: 20
}, {
  title: '标题',
  dataIndex: 'formName',
  key: 'formName',
  scopedSlots: {
    customRender: 'formName'
  },
  width: 90
}, {
  title: '',
  dataIndex: '',
  width: 15,
  scopedSlots: {
    customRender: 'formNameTmp'
  }
}, {
  title: '类型',
  dataIndex: 'cateName',
  key: 'cateName',
  width: 30
}, {
  title: '抄送人',
  dataIndex: 'userName',
  key: 'userName',
  width: 30
}, {
  title: '抄送时间',
  dataIndex: 'createTime',
  key: 'createTime',
  width: 50
}, {
  title: '状态',
  scopedSlots: {
    customRender: 'isRead'
  },
  width: 20
}, {
  title: '概述',
  dataIndex: 'summary',
  width: 20
}, {
  title: '操作',
  key: 'action',
  scopedSlots: {
    customRender: 'action'
  },
  width: 20
}];
export default {
  name: 'CopyMe',
  components: {},
  data: function data() {
    return {
      visible: false,
      visibleId: '',
      expand: false,
      loading: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      columns: columns,
      dataSource: [],
      selectedRows: [],
      total: 0,
      pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        total: this.total,
        pageSizeOptions: ['10', '20', '30', '40', '100'],
        showTotal: function showTotal(total) {
          return "\u5171 ".concat(total, " \u6761\u6570\u636E");
        },
        onShowSizeChange: this.pageSizeChange,
        onChange: this.pageChange
      },
      form: {
        pageSize: 10,
        currentNo: 1,
        summary: '',
        fillId: '',
        formName: undefined,
        cateId: undefined
      },
      cateList: [{
        cateId: 1,
        cateMemo: '',
        cateName: '行政',
        parentId: 0,
        sortNum: 1,
        status: 1,
        treeLevel: 0
      }]
    };
  },
  authorize: {
    deleteRecord: 'delete'
  },
  methods: {
    //表格行点击事件
    rowClick: function rowClick(record, index) {
      var _this = this;
      return {
        on: {
          dblclick: function dblclick() {
            _this.$router.push({
              path: '/formReview/reviewCenter/viewProcess',
              query: {
                procInsId: record.processInstanceId
              }
            });
          }
        }
      };
    },
    toggle: function toggle() {
      this.expand = !this.expand;
    },
    dbTwoClick: function dbTwoClick(row) {
      this.$router.push({
        path: '/formReview/reviewCenter/viewProcess',
        query: {
          procInsId: row.processInstanceId
        }
      });
    },
    handleVisibleChange: function handleVisibleChange(row) {
      // if (row.trackStatus == 2) {
      //     this.visible = true;
      // }
    },
    handlepopConfirmConfirm: function handlepopConfirmConfirm(row) {
      var _this2 = this;
      saveFlowTrack(row).then(function (res) {
        _this2.visible = false;
        _this2.onClicAfterMeApplyList();
      });
    },
    handlepopConfirmCancel: function handlepopConfirmCancel() {
      this.visible = false;
    },
    toSave: function toSave(row) {
      var _this3 = this;
      this.visibleId = row.processInstanceId;
      if (row.trackStatus == 2) {
        this.visible = true;
      } else {
        saveFlowTrack(row).then(function (res) {
          _this3.onClicAfterMeApplyList();
        });
      }
    },
    cz: function cz() {
      this.$refs.searchFrom.resetFields();
    },
    initDict: function initDict() {
      var that = this;
      getFormCate().then(function (res) {
        var list = res.data.data;
        that.cateList = list;
        that.loading = false;
      });
    },
    pageSizeChange: function pageSizeChange(val, pageNum) {
      this.loading = true;
      this.pagination.pageSize = pageNum;
      this.pagination.current = 1;
      this.form.pageSize = this.pagination.pageSize;
      this.form.currentNo = this.pagination.current;
      this.onClicCopyMeList(); //获取列表数据
    },
    pageChange: function pageChange(page, val) {
      this.loading = true;
      this.pagination.current = page;
      this.form.pageSize = this.pagination.pageSize;
      this.form.currentNo = this.pagination.current;
      sessionStorage.setItem('Pagination_copyMine', JSON.stringify(this.pagination));
      this.onClicCopyMeList(); //获取列表数据
    },
    queryTableList: function queryTableList() {
      this.form.currentNo = 1;
      this.pagination.current = 1;
      this.onClicCopyMeList();
      sessionStorage.removeItem('Pagination_copyMine');
    },
    onClicCopyMeList: function onClicCopyMeList() {
      var _this4 = this;
      queryFlowCopyMan(this.form).then(function (res) {
        var data = res.data.data;
        _this4.dataSource = data && Object.prototype.hasOwnProperty.call(data, 'rows') ? data.rows : [];
        _this4.total = data && Object.prototype.hasOwnProperty.call(data, 'total') ? data.total : 0;
        _this4.pagination.total = _this4.total;
        _this4.loading = false;
      });
    },
    loadData: function loadData() {
      this.onClicCopyMeList();
      this.initDict();
    },
    onViewCopyMeApply: function onViewCopyMeApply(text, record) {
      updateIsRead({
        copyId: record.copyId
      }).then(function (res) {});
      this.$router.push({
        path: '/formReview/reviewCenter/viewProcess',
        query: {
          procInsId: record.processInstanceId
        }
      });
    }
  },
  created: function created() {
    var savedPagination = sessionStorage.getItem('Pagination_copyMine');
    if (savedPagination) {
      try {
        var parsed = JSON.parse(savedPagination);
        this.pagination.current = parsed.current || 1;
        this.pagination.pageSize = parsed.pageSize || 10;
      } catch (e) {} finally {}
    }
    this.loadData();
  }
};